<template lang="pug">
  SspLayout(area="core")
    template(slot="actions")
      router-link.btn.btn-default(:to="{name: 'setCodeStatus'}") Code Input
    .panel.panel-default
      .panel-body
        .row
          .col-sm-6
            .form-horizontal
              .form-group
                .col-sm-4
                  span.bold Fail on invalid codes
                  span.ml10
                    input(type="checkbox" v-model="ignoreInvalidCodes")
                  span.ml10
                .col-sm-6
                  em.text-muted If checked the upload will fail if one code is invalid.

              .form-group
                .col-sm-12
                  input(type="file" @change="onFileChange")
              .form-group
                .col-sm-12
                  button.btn.btn-primary(@click="uploadFile" :disabled="!isValidFile")
                    i.fa.fa-upload
                    span.ml5 Upload File

          .col-sm-6
            .text-info Below is the format the file has to be in: code, codeStatusId
            hr
            span.kzcode-default abcd1234
            span , 5
            .row
            span.kzcode-default urn:kz:5:abcd1234
            span , 2
</template>

<script>
import miniToastr from 'mini-toastr'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    ignoreInvalidCodes: false,
    file: null
  }),
  methods: {
    onFileChange(e) {
      this.file = e.target.files || e.dataTransfer.files
    },
    uploadFile() {
      const data = new FormData()
      data.set('file', this.file[0])
      Core.uploadCodestatusFile(this.ignoreInvalidFileCodes, data)
        .then(() => {
          miniToastr.success('Code status set')
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    }
  },
  computed: {
    isValidFile() {
      return this.file
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/core/SetCodeStatusFileUpload.vue